import React, { Dispatch, SetStateAction, useState } from "react";
import styled from "styled-components";
import { toast } from "react-toastify";
import firebase from "firebase";

import { Button } from "@components/global";
import { fontFamilies } from "@util/constants";
import { A, Container, H2, P } from "@util/standard";

interface Props {
  setVisible: Dispatch<SetStateAction<boolean>>;
}

const Input = styled.input`
  border: none;
  border-bottom: 1px solid #000000;
  padding-bottom: 10px;
  margin-bottom: 25px;

  ::placeholder {
    font-size: 15px;
    font-family: ${fontFamilies.proximaNova};
  }

  :focus-visible {
    outline: none;
  }
`;

function ForgotPasswordForm({ setVisible }: Props) {
  const [inputValue, setInputValue] = useState("");
  const [formSubmitted, setformSubmitted] = useState(false);

  const forgotPassword = () => {
    if (inputValue === "" || !inputValue.includes("@")) {
      toast.error("Please enter a valid email address");
      return;
    }
    firebase
      .auth()
      .sendPasswordResetEmail(inputValue)
      .then(response => {
        toast.success("Password reset email sent");
        setformSubmitted(true);
      })
      .catch(error => {
        console.log(error);

        toast.error("something went wrong when trying to send confirmation email, please use a registered email");
      });
  };

  return (
    <Container width="100%" flexDirection="column">
      <H2 color="darkerGreen">Reset Password</H2>
      {!formSubmitted && (
        <>
          <P margin="25px 0 25px 0">A password reset email will be sent to the email entered below</P>
          <Input onChange={e => setInputValue(e.target.value)} placeholder="Password reset Email" />
          <Button margin="10px 0" text="Send email" theme="block" onClick={() => forgotPassword()} />
          <A width="max-content" margin="25px 0" underlined theme="text" onClick={() => setVisible(false)}>
            Return to login
          </A>
        </>
      )}
      {formSubmitted && (
        <>
          <P>A password reset email has been sent to {inputValue}</P>
          <Button width="70%" text="Login" theme="block" onClick={() => setVisible(false)} />
        </>
      )}
    </Container>
  );
}

export default ForgotPasswordForm;
